import React, { Component } from "react";
import PropTypes from "prop-types";
import Checkout from "components/WebOrder/Checkout";
import { Footer } from "components/CoreLayout";
import logo from "static/images/logo.png";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { MSpinner } from "components/Shared";

class CheckoutPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "Order not found or no longer available.",
      hasError: false
    };
  }

  componentDidMount() {
    const { match: { params } } = this.props;
    this.props.getCheckout(params.token);
  }

  componentDidUpdate () {
    const { checkout } = this.props;  
    const { hasError, errorMessage } = this.state;  
    if (checkout) {
      if (!checkout.result && !hasError) {
        this.setState({ hasError: true });
      } else if (checkout.result && checkout.result.error) {
        if(!hasError || errorMessage !== checkout.result.errorMessages){
          this.setState({ hasError: true, errorMessage: checkout.result.errorMessages });
        }
      } else if(checkout.result && hasError) {
        this.setState({ hasError: false });        
      }
    }    
  }
  
  render() {
    const { fetchingCheckout, savingCheckout, cancelingCheckout, checkout } = this.props;
    const { match: { params } } = this.props;
    const hasConfirmation = this.props.confirmationNumber;
    let hasError = this.state.hasError;

    return (
      <div className="app">
        <div className="app-header">
          <div>
            <img src={logo} alt="logo.png" style={{ width: "240px" }} />
          </div>
          <div className="top-menu-bar">
            <div className="md-cell--12"> Secure Guest Checkout </div>
          </div>
        </div>
        <div className="app-body md-grid md-cell md-cell--12" style={{ margin: 0, padding: 20, width: "100%" }}>
          {
            hasConfirmation &&
            <Card style={{ width: "50%", minWidth: "300px", marginLeft: "auto", marginRight: "auto", maxHeight: 200 }}>
              <CardContent><Typography variant="h6">Thank you for your order</Typography></CardContent>
              <CardContent className="md-grid">
                Your loan number is {this.props.confirmationNumber}. You will receive a confirmation e-mail shortly.
                </CardContent>
            </Card>
          }
          {
            hasError &&
            <div id="waiver-decision" className="md-grid md-cell waiver-wrapper">
              <div className="waiver-form">
                <img src={logo} alt="logo.png" className="mueller-logo" />
                <h3 className="mueller-title" data-test="title">Borrower Payment Request</h3>
                <div className="waiver-error">{this.state.errorMessage}</div>
                <div className="waiver-help">
                  If you have any questions regarding this order please contact Mueller Customer Service at <a href="mailto:customerservice@muellerreports.com">customerservice@muellerreports.com</a>.
                  </div>
              </div>
            </div>
          }
          {
            !hasError && !hasConfirmation && fetchingCheckout && <MSpinner />
          }
          {
            !hasError && !hasConfirmation && !fetchingCheckout &&
            <Checkout
              checkout={checkout}
              savingCheckout={savingCheckout}
              cancelingCheckout={cancelingCheckout}
              saveCheckout={this.props.saveCheckout}
              cancelCheckout={this.props.cancelCheckout}
              makeToast={this.props.makeToast}
              pushToConfirmationPage={this.props.pushToConfirmationPage}
              confirmationNumber={this.props.confirmationNumber}
              history={this.props.history}
              token={params.token}
            />
          }
        </div>
        <Footer rightMessage="Customer Service: 1-877-288-3573 | customerservice@muellerreports.com" />
      </div>
    );
  }
}

CheckoutPage.propTypes = {
  fetchingCheckout: PropTypes.bool.isRequired,
  savingCheckout: PropTypes.bool.isRequired,
  cancelingCheckout: PropTypes.bool.isRequired,
  checkout: PropTypes.object.isRequired,
  getCheckout: PropTypes.func.isRequired,
  saveCheckout: PropTypes.func.isRequired,
  cancelCheckout: PropTypes.func.isRequired,
  pushToConfirmationPage: PropTypes.func.isRequired,
  confirmationNumber: PropTypes.string,

  makeToast: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object,
  location: PropTypes.object
};
export default CheckoutPage;

